var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isPortal)?_c('router-view'):(_vm.isLoading)?_c('section-loading'):_c('div',[_c('Reseller',{attrs:{"reseller":_vm.reseller}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }